module.exports = __webpack_public_path__ + "static/media/level-up-alt.08584601.svg";